function fetchGeo() {
    const opts = { headers: { 'X-GEO-APP': 'ArkadiumAds' } };
    return fetch('https://geoip.cdn.arkadiumhosted.com/json/', opts)
        .then(response => response.json());
}
export function getGeo() {
    const w = window;
    w.__ark_ads__ = w.__ark_ads__ || {};
    w.__ark_ads__.geoPromise = w.__ark_ads__.geoPromise || fetchGeo();
    return w.__ark_ads__.geoPromise;
}
